import { Component, Input } from '@angular/core';

import { MenuItem } from '../../models/cube';

@Component({
  selector: 'cube-sidemenu-item',
  templateUrl: './sidemenu-item.component.html',
  standalone: false,
})
export class SidemenuItemComponent {
  @Input() menu: MenuItem;
  @Input() iconOnly: boolean;
  @Input() secondaryMenu = false;

  checkForChildMenu(): boolean {
    return !!this.menu?.sub;
  }
}
